document.addEventListener('DOMContentLoaded', function () {
  function setupKlaviyoToggle() {
    const toggles = document.querySelectorAll('[data-klaviyo-discount-toggle]');

    if (toggles.length === 0) {
      return;
    }

    let pending = false;

    toggles.forEach(function (toggle) {
      if (toggle.dataset.klaviyoDiscountInitialized === 'true') {
        return;
      }

      const formId = toggle.getAttribute('data-klaviyo-discount-toggle');
      const formContainer = document.getElementById(formId);

      if (!formContainer) {
        pending = true;
        return;
      }

      toggle.dataset.klaviyoDiscountInitialized = 'true';

      toggle.addEventListener('click', function (event) {
        event.preventDefault();

        if (formContainer.hasAttribute('hidden')) {
          formContainer.removeAttribute('hidden');
        } else {
          formContainer.setAttribute('hidden', '');
        }
      });
    });

    if (pending) {
      setTimeout(setupKlaviyoToggle, 1000);
    }
  }

  setupKlaviyoToggle();
});
